/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  ArrangePromptRequestBody,
  ArrangePromptResponse,
  CreatePromptRequestBody,
  CreatePromptResponse,
  DeletePromptResponse,
  GetPromptsParams,
  GetPromptsResponse,
  UpdatePromptRequestBody,
  UpdatePromptResponse
} from '../model';

import getPromptsMutator from '../../../mutators/datastore-instance';
import postPromptMutator from '../../../mutators/datastore-instance';
import putPromptMutator from '../../../mutators/datastore-instance';
import deletePromptMutator from '../../../mutators/datastore-instance';
import arrangePromptMutator from '../../../mutators/datastore-instance';



  /**
 * プロンプトの一覧・検索をする
 * @summary プロンプトの一覧・検索
 */
export const getPrompts = (
    params?: GetPromptsParams,
 ) => {
      return getPromptsMutator<GetPromptsResponse>(
      {url: `/prompts`, method: 'GET',
        params
    },
      );
    }
  /**
 * プロンプトの新規作成をする
 * @summary プロンプトの新規作成
 */
export const postPrompt = (
    createPromptRequestBody?: CreatePromptRequestBody,
 ) => {
      return postPromptMutator<CreatePromptResponse>(
      {url: `/prompts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPromptRequestBody
    },
      );
    }
  /**
 * プロンプトの更新をする
 * @summary プロンプトの更新
 */
export const putPrompt = (
    promptId: number,
    updatePromptRequestBody?: UpdatePromptRequestBody,
 ) => {
      return putPromptMutator<UpdatePromptResponse>(
      {url: `/prompts/${promptId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePromptRequestBody
    },
      );
    }
  /**
 * プロンプトの削除をする
 * @summary プロンプトの削除
 */
export const deletePrompt = (
    promptId: number,
 ) => {
      return deletePromptMutator<DeletePromptResponse>(
      {url: `/prompts/${promptId}`, method: 'DELETE'
    },
      );
    }
  /**
 * Arrange prompt (sort order)
 * @summary Arrange prompt
 */
export const arrangePrompt = (
    arrangePromptRequestBody?: ArrangePromptRequestBody,
 ) => {
      return arrangePromptMutator<ArrangePromptResponse>(
      {url: `/prompts/arrange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: arrangePromptRequestBody
    },
      );
    }
  export type GetPromptsResult = NonNullable<Awaited<ReturnType<typeof getPrompts>>>
export type PostPromptResult = NonNullable<Awaited<ReturnType<typeof postPrompt>>>
export type PutPromptResult = NonNullable<Awaited<ReturnType<typeof putPrompt>>>
export type DeletePromptResult = NonNullable<Awaited<ReturnType<typeof deletePrompt>>>
export type ArrangePromptResult = NonNullable<Awaited<ReturnType<typeof arrangePrompt>>>
